export const ANALYTICS_CONSENT_COOKIE = "zipvibe_analytics_consent";

const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

export type AnalyticsConsent = "accepted" | "rejected";

export function parseAnalyticsConsent(value: string | null | undefined): AnalyticsConsent | null {
  if (value === "accepted" || value === "rejected") {
    return value;
  }

  return null;
}

export function readAnalyticsConsentFromCookieHeader(cookieHeader: string | null | undefined): AnalyticsConsent | null {
  if (!cookieHeader) return null;

  const target = `${ANALYTICS_CONSENT_COOKIE}=`;
  const parts = cookieHeader.split(";");

  for (const part of parts) {
    const segment = part.trim();
    if (!segment.startsWith(target)) continue;

    const rawValue = segment.slice(target.length);
    return parseAnalyticsConsent(decodeURIComponent(rawValue));
  }

  return null;
}

export function buildAnalyticsConsentCookieValue(
  consent: AnalyticsConsent,
  options?: { secure?: boolean }
): string {
  const secure = options?.secure ?? false;

  const attributes = [
    `${ANALYTICS_CONSENT_COOKIE}=${encodeURIComponent(consent)}`,
    "Path=/",
    `Max-Age=${ONE_YEAR_IN_SECONDS}`,
    "SameSite=Lax",
  ];

  if (secure) {
    attributes.push("Secure");
  }

  return attributes.join("; ");
}
